module.exports = __webpack_public_path__ + "img/sprint-empty-todo.7dfb858a.svg";